import { Link } from 'react-router-dom';

const footerLinks = {
  services: [
    { label: '体育培训', href: '/categories?tab=training' },
    { label: '赛事组织', href: '/categories?tab=events' },
    { label: '运动装备', href: '/categories?tab=equipment' },
    { label: '场馆管理', href: '/categories?tab=venues' },
  ],
  about: [
    { label: '品牌介绍', href: '/about' },
    { label: '荣誉资质', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
  ],
  articles: [
    { label: '体育资讯', href: '/articles' },
    { label: '培训指南', href: '/articles?category=training' },
    { label: '赛事动态', href: '/articles?category=events' },
    { label: '装备评测', href: '/articles?category=equipment' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-6 md:px-8">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-basketball-line text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-semibold font-heading tracking-wide text-background-50">
                  云开体育
                </span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed mb-4">
                专注体育运动领域的综合服务平台，提供体育培训、赛事组织、运动装备及场馆管理等一站式解决方案。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-600 text-background-100 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-600 text-background-100 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-600 text-background-100 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">服务项目</h4>
              <ul className="space-y-2.5">
                {footerLinks.services.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                {footerLinks.about.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <div className="space-y-3">
                <div className="flex items-start gap-2.5">
                  <i className="ri-phone-line text-primary-400 text-sm mt-0.5"></i>
                  <span className="text-sm text-foreground-300">400-888-6666</span>
                </div>
                <div className="flex items-start gap-2.5">
                  <i className="ri-mail-line text-primary-400 text-sm mt-0.5"></i>
                  <span className="text-sm text-foreground-300">contact@yunkai-sports.com</span>
                </div>
                <div className="flex items-start gap-2.5">
                  <i className="ri-map-pin-line text-primary-400 text-sm mt-0.5"></i>
                  <span className="text-sm text-foreground-300">上海市浦东新区张江高科技园区体育中心A座</span>
                </div>
                <div className="flex items-start gap-2.5">
                  <i className="ri-time-line text-primary-400 text-sm mt-0.5"></i>
                  <span className="text-sm text-foreground-300">周一至周日 9:00 - 21:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            © 2026 云开体育 版权所有 | 沪ICP备2024000000号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}